module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-5-en-US-9f0524fcdcc2b6d60f3b601099fa732c.png";